import { useEffect, useState } from 'react';
import { useModalContext } from '@/features/world-map/context/modal';
import { useMapViewport } from '@/features/world-map/hooks/use-map-viewport';
import { Cruises, CruisesHeader } from '../../cruises';
import { Panel } from '@/ui/panel/panel';

const autoOpenZoom = 4;

export function DesktopPanel() {
  const { zoom } = useMapViewport();
  const { activeModalId } = useModalContext();
  const [isOpen, setIsOpen] = useState(true);
  const [hasBeenOpened, setHasBeenOpened] = useState(isOpen);

  useEffect(() => {
    if (!isOpen && !hasBeenOpened && zoom >= autoOpenZoom) {
      handleIsOpenChange(true);
    }
  }, [zoom, hasBeenOpened, isOpen]);

  /**
   * @param {boolean} value
   * @returns {void}
   */
  const handleIsOpenChange = (value) => {
    if (value) {
      setHasBeenOpened(true);
    }
    setIsOpen(value);
  };

  return (
    <Panel label="Itineraries" isOpen={isOpen} isOpenChange={handleIsOpenChange} hidden={Boolean(activeModalId)}>
      <CruisesHeader />
      <Cruises />
    </Panel>
  );
}
